import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { Logo } from "./Navbar";
import { ContactLines, DirectionsButton } from "./Contact";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-white/10 bg-black" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-3 lg:px-10">
        <div>
          <Logo className="h-14" />
          <p className="mt-4 max-w-xs text-sm text-slate-400">{t("footer.tagline")}</p>
        </div>
        <div><ContactLines id="footer" compact /></div>
        <div className="flex flex-col items-start gap-4 md:items-end">
          <DirectionsButton id="footer" />
          <p className="font-mono text-xs text-slate-500">24/7 · {t("amen.metro")}</p>
        </div>
      </div>
      <div className="border-t border-white/5 py-5 text-center font-mono text-xs text-slate-600">
        © {new Date().getFullYear()} RECORDING ROOM. {t("footer.rights")}
        <span className="mt-2 flex justify-center gap-4">
          <Link to="/terms" data-testid="footer-terms-link" className="hover:text-white">{t("footer.terms")}</Link>
          <Link to="/rules" data-testid="footer-rules-link" className="hover:text-white">{t("footer.rules")}</Link>
          <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white">{t("footer.privacy")}</Link>
        </span>
      </div>
    </footer>
  );
}
